import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/outline";
import { TooltipCircle } from "components/tooltipCircle";
import { ReactNode, useState } from "react";
import { UnmountClosed } from "react-collapse";
import { twMerge } from "tailwind-merge";

interface CollapsibleSectionProps {
  label: string;
  customSubLabel?: ReactNode;
  defaultOpen?: boolean;
  customOpen?: {
    open: boolean;
    onClick: () => void;
  };
  children: ReactNode;
  toolbar?: ReactNode;
  additionalLabel?: string | ReactNode;
  isAnimated?: boolean;
  headerProps?: any;
  hideArrow?: boolean;
  hideContent?: boolean;
  hint?:string;
  [x: string]: any;
}

export const CollapsibleSection = ({
  children,
  label,
  defaultOpen = true,
  toolbar,
  customOpen,
  headerProps,
  additionalLabel,
  isAnimated = true,
  className,
  hideArrow = false,
  hideContent = false,
  hint,
  customSubLabel,
  ...rest
}: CollapsibleSectionProps) => {
  const [isOpened, setIsOpened] = useState<boolean>(defaultOpen);
  return (
    <div
      className={twMerge(`box-container p-0 ${isAnimated ? "collapse-animated" : ""}`, className)}
      {...rest}
    >
      <div
        className="flex justify-between items-center gap-3 px-4 py-4 sm:px-6 hover:cursor-pointer"
        onClick={() =>
          customOpen ? customOpen.onClick() : setIsOpened(!isOpened)
        }
        {...headerProps}
      >
        <div className="min-w-0 flex-1">
          <p className="font-bold" style={{wordBreak: "break-word"}}>
            {label} {hint ? <TooltipCircle text={hint} /> : <></>}
          </p>
          {customSubLabel}
        </div>
        <div className="min-w-0 flex flex-row flex-wrap items-center justify-end gap-x-2 gap-y-2">
          {additionalLabel ? additionalLabel : <></>}
          <div>{toolbar}</div>
          {!hideArrow ? (
            <>
              <div className="mx-1 self-center h-5 w-[1px] bg-gray-300"></div>
              {(customOpen ? customOpen.open : isOpened) ? (
                <ChevronUpIcon className="w-5 h-5 text-brand-500" />
              ) : (
                <ChevronDownIcon className="w-5 h-5 text-brand-500" />
              )}
            </>
          ) : <></>}
        </div>
      </div>
      <UnmountClosed isOpened={hideContent ? false : customOpen ? customOpen.open : isOpened}>
        <div className="border-t border-gray-100" aria-hidden="true">{children}</div>
      </UnmountClosed>
    </div>
  );
};
